"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const core_1 = require("@nestjs/core");
const authorization_service_1 = require("../../modules/authorization/authorization.service");
const permissions_decorator_1 = require("../decorators/permissions.decorator");
let PermissionsGuard = class PermissionsGuard {
    constructor(reflector, authorizationService) {
        this.reflector = reflector;
        this.authorizationService = authorizationService;
    }
    async canActivate(ctx) {
        const required = this.reflector.getAllAndOverride(permissions_decorator_1.PERMISSIONS_KEY, [
            ctx.getHandler(),
            ctx.getClass(),
        ]);
        if (!required?.length)
            return true;
        const { user } = ctx.switchToHttp().getRequest();
        const hasPermissions = this.authorizationService.hasAllPermissions(user?.permissions, required);
        if (!hasPermissions) {
            throw new common_1.ForbiddenException('Insufficient permissions');
        }
        return true;
    }
};
exports.PermissionsGuard = PermissionsGuard;
exports.PermissionsGuard = PermissionsGuard = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof core_1.Reflector !== "undefined" && core_1.Reflector) === "function" ? _a : Object, typeof (_b = typeof authorization_service_1.AuthorizationService !== "undefined" && authorization_service_1.AuthorizationService) === "function" ? _b : Object])
], PermissionsGuard);
